import Api from "@nextories/vue-tasks/src/utils/Api";

export default class AppApi extends Api {
  /**
   * Retrieve the project of the current user from the backend
   * @returns {Promise<Object>} resolve with the project for the current user
   * or reject with the backend error message
   */

  // Dashboard
  getCountCalls(): Promise<any> {
    return this._nxtGetData('/n1/count/crm_queue_get_relances_type');
  }
  getCountOngoingRequest(): Promise<any> {
    return this._nxtGetData('/n1/dashboard/ongoing-requests');
  }
  getCountMeetingsToday(): Promise<any> {
    return this._nxtGetData('/n1/dashboard/meetings-today');
  }
  // End Dashboard

  getProject(): Promise<any> {
    return this._nxtGetData(`/n1/config/${this.projectToken}`);
  }

  getNextSheet(query: string): Promise<any> {
    return this._nxtGetData(`/n1/next${query ? `?${query}` : ''}`);
  }

  getOpenSheet(): Promise<any> {
    return this._nxtGetData(`/n1/open/${this.projectToken}`);
  }

  getCloseSheet(query: string): Promise<any> {
    return this._nxtGetData(`/n1/close/${this.projectToken}${query ? `?${query}` : ""}`);
  }

  getSearchProjects(query: string): Promise<any> {
    return this._nxtGetData(`/n1/search-demenagement${query ? `?${query}` : ""}`);
  }

  getMovers(): Promise<any> {
    return this._nxtGetData(`/static/list-movers?crm_id=${this.projectId}`);
  }

  postSaveData(request: {}): Promise<any> {
    return this._nxtPostData(`/n1/save/${this.projectToken}`, request);
  }

  postTypeMeeting(typeMeeting: string) {
    return this._nxtGetData(
      `/booking/meeting-type/${this.projectToken}?type_meeting=${typeMeeting}`,
    );
  }

  // Estimation
  postAllowEstimate(request: {}) {
    return this._nxtPostData("/booking/check-allow-estimate/", request);
  }

  getEstimate() {
    return this._nxtGetData(`/static/estimation/${this.projectToken}`);
  }
  // End estimation

  // Tasks
  calcEstimation(request: {}) {
    return this._nxtPostData(`/static/estimation/`, request);
  }

  getListTasksType() {
    return this._nxtGetData("/n1/list-tasks-type");
  }

  getTasks(request: {}) {
    return this._nxtPostData("/n1/list-calls", request);
  }

  getCountTasks(request: { count_tasks?: boolean }) {
    request.count_tasks = true;
    return this._nxtPostData("/n1/list-calls", request);
  }

  postUpdateMultitasks(request: {}): Promise<any> {
    return this._nxtPostData("/n1/update-multicalls", request);
  }

  postTask(request: {}): Promise<any> {
    return this._nxtPostData("/n1/update-call", request);
  }

  updateTask(request: {}): Promise<any> {
    return this._nxtPostData("/n1/update-call", request);
  }

  deleteTask(id: string): Promise<any> {
    return this._nxtPostData(`/n1/delete-call/${id}`);
  }
  // End tasks
}
